module.exports = __webpack_public_path__ + "img/busca-avancada-peixes-aquicultura-2.0ee19bf7.jpg";